import { useEffect, useRef, useState } from "react";
import { Container } from "../../styles";
import { T2 } from "../../../../styles/titles";
import { FormFilter } from "./components/filter/filters";
import { LiveTable } from "./components/liveTable/liveTable";
import { Totals } from "./components/totals/totals";
import HistoryAnticipationService from "./service/historyAnticipationService";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import { AnticipationHistoryTableData, TotalsDataHistory } from "./types";

const AnticipationHistory: React.FC = () => {
  const [filterData, setFilterData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [totals, setTotals] = useState<TotalsDataHistory | null>(null);
  const [tableData, setTableData] = useState<AnticipationHistoryTableData>({
    records: [],
    count: 0,
  });
  const [pageSize, setPageSize] = useState<number>(20);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const effectRan = useRef(false);
  const historyAnticipationService = new HistoryAnticipationService();

 
  const fetchAllData = async () => {
    setIsLoading(true);
    try {
      const response = await historyAnticipationService.getHistoryAnticipation(
      currentPage,
      pageSize,
      filterData
    );

    setTableData({
      records: response.data.records || [],
      count: response.data.rowCount || 0,
    });

    setTotals({
      
      totalLiquid: response.data.totalLiquid,
      totalNewLiquid: response.data.totalNewLiquid ,        
      totalRevenue: response.data.totalRevenue,
      rowCount: response.data.rowCount
    });

    } catch (error) {
      console.error("Erro ao buscar dados: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => { 
  if (filterData) {
    fetchAllData();
  }
}, [currentPage, pageSize, filterData]);

  return (
    <Container>
      <LoadingOverlay show={isLoading} relative />
      <T2>Histórico de Antecipações</T2>
      {totals && <Totals data={totals} />}
      <FormFilter getFilters={(data) => setFilterData(data)} />
      {tableData && (
        <LiveTable
          data={tableData}
          currentPage={currentPage}
          pageSize={pageSize}
          onPageChange={setCurrentPage}
          onPageSizeChange={setPageSize}
        />
      )}
    </Container>
  );
};

export default AnticipationHistory;
